import React, { useRef, useState } from 'react';

const SWIPE_THRESHOLD = 60;

export function SwipeableCard({ children, onSwipeLeft, onSwipeRight, leftLabel, rightLabel, leftColor, rightColor, className = '', style = {} }) {
  const touchStartRef = useRef({ x: 0, y: 0 });
  const [offset, setOffset] = useState(0);
  const [swiping, setSwiping] = useState(false);

  const handleTouchStart = (e) => {
    touchStartRef.current = { x: e.touches[0].clientX, y: e.touches[0].clientY };
    setSwiping(true);
  };

  const handleTouchMove = (e) => {
    if (!swiping) return;
    const dx = e.touches[0].clientX - touchStartRef.current.x;
    const dy = e.touches[0].clientY - touchStartRef.current.y;
    // Only horizontal swipes
    if (Math.abs(dy) > Math.abs(dx)) {
      setSwiping(false);
      setOffset(0);
      return;
    }
    // Dampen the offset
    setOffset(dx * 0.5);
  };

  const handleTouchEnd = () => {
    if (offset > SWIPE_THRESHOLD && onSwipeRight) {
      onSwipeRight();
    } else if (offset < -SWIPE_THRESHOLD && onSwipeLeft) {
      onSwipeLeft();
    }
    setOffset(0);
    setSwiping(false);
  };

  const showingLeft = offset < -20;
  const showingRight = offset > 20;

  return (
    <div className="relative overflow-hidden rounded-xl sm:rounded-2xl" data-testid="swipeable-card">
      {/* Background action labels */}
      {showingLeft && onSwipeLeft && (
        <div className="absolute inset-0 flex items-center justify-end px-4 rounded-xl sm:rounded-2xl"
          style={{ background: leftColor || 'rgba(239,68,68,0.15)' }}>
          <span className="text-xs font-bold uppercase" style={{ color: leftColor ? '#fff' : '#EF4444' }}>
            {leftLabel || 'Toggle Off'}
          </span>
        </div>
      )}
      {showingRight && onSwipeRight && (
        <div className="absolute inset-0 flex items-center justify-start px-4 rounded-xl sm:rounded-2xl"
          style={{ background: rightColor || 'rgba(34,197,94,0.15)' }}>
          <span className="text-xs font-bold uppercase" style={{ color: rightColor ? '#fff' : '#22C55E' }}>
            {rightLabel || 'Toggle On'}
          </span>
        </div>
      )}

      {/* Card content */}
      <div
        className={className}
        style={{
          ...style,
          transform: `translateX(${offset}px)`,
          transition: swiping ? 'none' : 'transform 0.3s ease-out',
        }}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {children}
      </div>
    </div>
  );
}
